import { TConfig } from '@@/interfaces';

const config: DeepPartial<TConfig> = {};

export default config;
